import { gql } from '@apollo/client';

import { documentFragment } from '../fragments';

export const createExternalDocumentMutation = gql`
  mutation CreateExternalDocument(
    $courseId: String!
    $subjectId: String!
    $input: CreateExternalDocumentInput!
  ) {
    createExternalDocument(
      courseId: $courseId
      subjectId: $subjectId
      input: $input
    )
      @rest(
        type: "Document"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/documents/external"
        method: "POST"
      ) {
      ...Document
    }
  }
  ${documentFragment}
`;
